import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './styles.scss';

function RightLabel({ rightLabel, labelClassName }) {
  return (
    <>
      {typeof rightLabel === 'string' ? (
        <span
          className={`${styles.rightLabel}${
            labelClassName ? ` ${labelClassName}` : ''
          }`}
        >
          {rightLabel}
        </span>
      ) : (
        rightLabel
      )}
    </>
  );
}

const Checkbox = React.memo((props) => {
  const {
    className,
    name,
    onChange,
    onBlur,
    isChecked,
    isDisabled,
    leftLabel,
    rightLabel,
    errorLabel,
    labelClassName,
    errorTextClassName,
    style,
  } = props;

  function getCheckboxLaneButtonClassNames() {
    return classNames({
      [styles.checkboxCheckedLaneButton]: true,
      [styles.isDisabled]: isDisabled,
      [className]: !!className,
    });
  }

  function handleChange(event) {
    onChange(event, props);
  }

  return (
    <div className={styles.checkboxGroup}>
      <label className={getCheckboxLaneButtonClassNames()}>
        {leftLabel && (
          <span
            className={`${styles.leftLabel}${
              labelClassName ? ` ${labelClassName}` : ''
            }`}
          >
            {leftLabel}
          </span>
        )}
        <input
          className={styles.inputCheckBox}
          type="checkbox"
          name={name}
          disabled={isDisabled}
          checked={isChecked}
          onChange={handleChange}
          onBlur={onBlur}
        />
        <span className={styles.customCheckbox} style={style} />
        {rightLabel && (
          <RightLabel rightLabel={rightLabel} labelClassName={labelClassName} />
        )}
      </label>
      {errorLabel && (
        <span
          className={`${styles.errorText}${
            errorTextClassName ? ` ${errorTextClassName}` : ''
          }`}
        >
          {errorLabel}
        </span>
      )}
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

Checkbox.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelClassName: PropTypes.string,
  errorTextClassName: PropTypes.string,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  errorLabel: PropTypes.string,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default Checkbox;
